export const SET_TO_UID = 'SET_TO_UID';
export const GET_TO_UID = 'GET_TO_UID';

export default {
    namespaced: true,
    state:{
        toUid: '',
    },
    mutations: {
        [SET_TO_UID](state, toUid) {
            state.toUid = toUid;
        },
    },
    getters: {
        [GET_TO_UID](state) {
            return state.toUid
        },
    }
}